import {gql} from "@apollo/client";
import { DeliveryTaskOrderType, DELIVERY_TASK_ORDER_FIELDS } from "../types/DeliveryTaskOrderType";
import { client } from "graphql/client";

export const TRANSFER_IN_DELIVERY_SCAN = gql`
  mutation DeliveryMutation($input: ScanInput!) {
    result: handleTransferInDeliveryScanEvent(input: $input) {
      ...DeliveryTaskOrderFields
    }
  }
  ${DELIVERY_TASK_ORDER_FIELDS}
`;

interface TransferInDeliveryScanResponse {
    result: DeliveryTaskOrderType;
}

export interface TransferInScanInput {
    trackingNumber: string;
    scanLocation: {
        latitude: number;
        longitude: number;
    };
}

interface TransferInScanInputVariables {
    input: TransferInScanInput;
}

export const handleTransferInDeliveryScanEvent = async (input: TransferInScanInput): Promise<DeliveryTaskOrderType | undefined>  => {
      const { data } = await client.mutate<TransferInDeliveryScanResponse, TransferInScanInputVariables>({
        mutation: TRANSFER_IN_DELIVERY_SCAN,
        variables: { input },
    });
    return data?.result;
};